module.exports = __webpack_public_path__ + "static/media/DIAMOND-11-JACK.1faf0a59.svg";